import React, { useEffect, useState } from 'react';
import FarmfleetLogoMark from './components/FarmfleetLogoMark';
import './Loader.css';

function Loader({ onComplete }) {
  const [progress, setProgress] = useState(0);
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    const duration = 2500;
    const interval = 50;
    const increment = (100 / duration) * interval;
    let current = 0;

    const timer = setInterval(() => {
      current += increment;
      if (current >= 100) {
        setProgress(100);
        clearInterval(timer);
        setExiting(true);
        setTimeout(() => onComplete?.(), 500);
      } else {
        setProgress(current);
      }
    }, interval);

    return () => clearInterval(timer);
  }, [onComplete]);

  return (
    <div className={`loader ${exiting ? 'loader-exit' : ''}`}>
      <div className="loader-bg" />
      <div className="loader-overlay" />
      <div className="loader-content">
        <div className="loader-logo">
          <div className="loader-logo-icon">
            <FarmfleetLogoMark />
          </div>
          <h1 className="loader-title">FARMFLEET</h1>
          <p className="loader-subtitle">Agricultural Logistics Platform</p>
        </div>
        <div className="loader-bar">
          <div className="loader-bar-fill" style={{ width: `${progress}%` }} />
        </div>
        <p className="loader-percent">{Math.round(progress)}%</p>
      </div>
    </div>
  );
}

export default Loader;
